import React, { useEffect, useState, useContext } from "react";
import InfoIcon2 from '../../../../../../assets/images/info_icon.svg';
import InfoIcon from '../../../../../../assets/images/info_icon_2.png';
import InfoIcon3 from '../../../../../../assets/images/info_icon_3.png';

import DatePicker from "react-datepicker";
// The CSS for DatePicker is imported in the application.css file (annoyingly)


function FormField(props) {
    return (
        <div className={'form-group w-100'}>
            <div className="inline-flex-label mb-2">
                <label className="form-label my-0">{props.label}</label>
                {props.tooltip && <img className="px-2" src={InfoIcon} data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title={props.tooltip} />}
            </div>
            <input name={props.name} id={props.id} required onChange={(event) => props.onChange(event)}
                className="form-control style-black" placeholder={props.placeholder}
                type={props.type} autoComplete={props.autoComplete}
                defaultValue={props.defaultValue} value={props.value}
                textarea={props.textarea}
            />
        </div>
    )

}

function CommentField(props) {
    const numRows = props.numRows || 4;
    return (
        <div className={'form-group w-100'}>
            <div className="inline-flex-label mb-2">
                <label className="form-label my-0">{props.label}</label>
                {props.tooltip && <img className="px-2" src={InfoIcon} data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title={props.tooltip} />}
            </div>
            <textarea name={props.name} id={props.id} required onChange={(event) => props.onChange(event)}
                className="form-control style-black" placeholder={props.placeholder}
                type={props.type} autoComplete={props.autoComplete}
                defaultValue={props.defaultValue} value={props.value}
                rows={numRows} cols="40"
            />
        </div>
    )

}

function IntegerField(props) {
    return (
        <div className={'form-group w-100'}>
            {props.label &&
                <div className="inline-flex-label mb-2">
                    <label className="form-label my-0">{props.label}</label>
                    {props.tooltip && <img className="px-2" src={InfoIcon} data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title={props.tooltip} />}
                </div>
            }
            <input name={props.name} id={props.id} required onChange={(event) => props.onChange(event)}
                className="form-control style-black" placeholder={props.placeholder} type="number"
                autoComplete={props.autoComplete} value={props.value}
                min={props.min} max={props.max} step={props.step}
            />
        </div>
    )

}

// function TextEntryQuestion(props) {
//     return (
//         <div className='form-group mb-4 w-100'>
//             <label className="form-label">{props.label}</label>
//             <input name={props.name} id={props.id} required onChange={(event) => props.onChange(event.target.value)} className="form-control" placeholder={props.placeholder} type={props.type} />
//         </div>
//     )
// }

// function MultipleChoiceQuestion(props) {
//     return (
//         <div className='form-group mb-4 w-100'>
//             <label className="form-label onboarding-label">{props.questionText}</label>
//             <div>
//                 {props.children}
//             </div>
//         </div>
//     )
// }


// function RadioOption(props) {
//     const classes = "form-check-input custom-radio-color"


//     return (
//         <div className="checkbox-wrapper my-2">
//             <input
//                 className={classes}
//                 type='radio'
//                 name={props.name}
//                 id={props.id}
//                 value={props.value}
//                 onChange={() => props.onChange(props.value)}
//             />
//             <label className="form-check-label onboarding-label" htmlFor={props.id}>
//                 {props.label}
//             </label>
//         </div>
//     )
// }

// function CheckboxOption(props) {
//     const classes = "form-check-input custom-checkbox-color"

//     return (
//         <div className="checkbox-wrapper my-2">
//             <input
//                 className={classes}
//                 type='checkbox'
//                 name={props.name}
//                 id={props.id}
//                 value={props.value}
//                 onChange={(event) => props.onChange(event.target.checked)}
//             />
//             <label className="form-check-label onboarding-label" htmlFor={props.id}>
//                 {props.label}
//             </label>
//         </div>
//     )
// }

function BareTextField(props) {
    const classSize = props.size == "small" ? "researcher-input small" : props.size == "large" ? "researcher-input large" : "researcher-input";
    return (
        <input
            name={props.name}
            id={props.id}
            onChange={(event) => props.onChange(event)}
            className={classSize}
            placeholder={props.placeholder}
            value={props.value}
            type="text"
        />
    )

}



function DropdownQuestion(props) {
    const placeholderSelection = props.placeholder && <DropdownOption isDisabled={true} value="-1"> {props.placeholder} </DropdownOption>
    const marginClass = props.marginClass || "";
    const widthClass = props.widthClass || "w-100";
    const defaultValue = props.defaultValue || "-1";
    return (
        <div className={'form-group ' + marginClass + ' ' + widthClass}>
            {(props.questionText || props.tooltip) && (
                <div className="inline-flex-label mb-2">
                    {props.questionText ? <label className="form-label onboarding-label my-0">{props.questionText}</label> : <></>}
                    {props.tooltip && <img className="px-2" src={InfoIcon} data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title={props.tooltip} />}
                </div>
            )}
            <select className="form-select custom-select-new" name={props.name} onChange={(event) => props.onChange(event)} id={props.id} value={props.value} defaultValue={defaultValue} aria-label={props.ariaLabel}>
                {placeholderSelection}
                {props.children}
            </select>
        </div>
    )
}

function DropdownOption(props) {
    return (
        <option disabled={props.isDisabled} className="form-control" value={props.value}>{props.children}</option>
    )
}

function NewIntegerField(props) {
    return (
        <div className={'form-group researcher-label-and-question-div'}>
            {props.label &&
                <div className="researcher-label-and-tooltip-div">
                    <label className="researcher-label">{props.label}</label>
                    {props.tooltip && <img className="" src={InfoIcon} data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title={props.tooltip} />}
                </div>
            }
            <input name={props.name} id={props.id} required onChange={(event) => props.onChange(event)}
                className="form-control researcher-input-create" placeholder={props.placeholder} type="number"
                autoComplete={props.autoComplete} value={props.value}
                min={props.min} max={props.max} step={props.step}
                style={props.inputStyle}
            />
        </div>
    )

}


function NewDecimalField(props) {
    return (
        <div className={'form-group researcher-label-and-question-div'}>
            {props.label &&
                <div className="researcher-label-and-tooltip-div">
                    <label className="researcher-label">{props.label}</label>
                    {props.tooltip && <img className="" src={InfoIcon} data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title={props.tooltip} />}
                </div>
            }
            <input name={props.name} id={props.id} required onChange={(event) => props.onChange(event)}
                className="form-control researcher-input-create" placeholder={props.placeholder} type="number"
                autoComplete={props.autoComplete} value={props.value}
                style={props.inputStyle}
            />
        </div>
    )

}

function NewDropdownQuestion(props) {
    const placeholderSelection = props.placeholder && <NewDropdownOption isDisabled={true} value="-1"> {props.placeholder} </NewDropdownOption>
    const selectColorClass = props.whiteText ? " white-text" : "";
    return (
        <div className="researcher-label-and-question-div">
            {(props.questionText || props.tooltip) && (
                <div className="researcher-label-and-tooltip-div">
                    {props.questionText ? <label className="researcher-label">{props.questionText}</label> : <></>}
                    {props.tooltip && <img className="" src={InfoIcon3} width={16} height={16} data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title={props.tooltip} />}
                </div>
            )}
            <select className={"form-select researcher-select-create" + selectColorClass} name={props.name} onChange={(event) => props.onChange(event)} id={props.id} value={props.value} defaultValue={props.defaultValue} aria-label={props.ariaLabel}>
                {placeholderSelection}
                {props.children}
            </select>
        </div>
    )
}

function NewDropdownOption(props) {
    // This doesn't work.
    const className = "researcher-option" + (props.isDisabled ? " grayed-out" : "");
    return (
        <option disabled={props.isDisabled} className={className} value={props.value}>{props.children}</option>
    )
}

function DatePickerField(props) {
    // Maintain date state specifically.
    const [date, setDate] = useState(null);

    const handleDateChange = (selectedDate) => {
        setDate(selectedDate);
        if (props.onChange) {
            props.onChange(selectedDate);
        }
    };

    return (

        <div className={'form-group researcher-label-and-question-div'}>
            {props.label &&
                <div className="researcher-label-and-tooltip-div">
                    <label className="researcher-label">{props.label}</label>
                    {props.tooltip && <img className="" src={InfoIcon} data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title={props.tooltip} />}
                </div>
            }
            <DatePicker
                onChange={handleDateChange}
                selected={date}
                placeholderText={"E.g. " + props.placeholder}
                showIcon
                dateFormat="yyyy-MM-dd"
                className="dark-datepicker-input"
                calendarClassName="dark-calendar"
                icon={
                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 20 20"><path fill="#c1c1c1" d="M6 1.5V4H2v5h20V4h-4V1.5h-2V4H8V1.5zM22 22V11H2v11z" /></svg>
                }
            />
        </div>
    )


}

export { FormField, DropdownQuestion, DropdownOption, IntegerField, CommentField, BareTextField, NewDropdownQuestion, NewDropdownOption, NewIntegerField, NewDecimalField, DatePickerField };